module.exports = __webpack_public_path__ + "assets/img/ea671f4202638b83b10fef9b07d2b9d0.png";